import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IconCircle } from '@ui-library/dottedCircle';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Svg from '@svg/index';
import Tooltip from '@ui-library/tooltip';
import Button from '@ui-library/button';

import EditName from './editName';
import classes from './header.module.scss';

export interface DescriptionProps {
  name: string;
  defName: string;
  handleNameSave: (name: string) => void;
  showCopyIcon: boolean;
  handleCopy?: () => void;
  validateInput: (input: string) => string;
  displayName?: string;
  isDestination?: boolean;
  isAdmin: boolean;
}

interface BackButton {
  label: string;
  linkTo: string;
}

export interface NavigationProps {
  name: string;
  backButton: BackButton;
}

const Navigation: React.FC<NavigationProps> = ({ name, backButton }) => (
  <div className={classes.back_button_container}>
    <Button textSecondary type="link" className={classes.arrow_button}>
      <Link to={backButton.linkTo}>
        <Svg name="short-left" />
      </Link>
    </Button>
    <Button textPrimary type="link" className={classes.all_entities_link}>
      <Link to={backButton.linkTo}>{backButton.label}</Link>
    </Button>
    <span> / {name}</span>
  </div>
);

const Description: React.FC<DescriptionProps> = ({
  name,
  defName,
  handleNameSave,
  showCopyIcon,
  validateInput,
  handleCopy,
  displayName,
  isDestination,
  isAdmin,
}: DescriptionProps) => {
  const [showEdit, setShowEdit] = useState(false);
  return (
    <div className={classes.description_container}>
      <IconCircle name={defName || ''} destination={isDestination} />
      <div className={classes.data_container}>
        <div className={classes.cta_container}>
          {showEdit ? (
            <EditName
              onClose={() => setShowEdit(false)}
              onSave={handleNameSave}
              validateInput={validateInput}
              initialName={name}
            />
          ) : (
            <div className={classes.name}>{name}</div>
          )}
          {!showEdit && isAdmin ? (
            <Tooltip title="Rename">
              <Button
                textSecondary
                type="text"
                className={classes.edit_button}
                onClick={() => {
                  setShowEdit(true);
                }}
              >
                <Svg name="edit" />
              </Button>
            </Tooltip>
          ) : null}
          {showCopyIcon && (
            <Tooltip title="Duplicate destination">
              <Button
                textSecondary
                type="text"
                className={classes.edit_button}
                onClick={handleCopy}
                data-testid="copy-button"
              >
                <FontAwesomeIcon icon={regular('copy')} />
              </Button>
            </Tooltip>
          )}
        </div>
        <div className={classes.def_name}>{displayName || defName}</div>
      </div>
    </div>
  );
};

export { Navigation, Description };
